<template>

  <div class="layout__container layout__padding-20-0">
    <div class="layout__padding-clear layout__width-800px">
      <StepGuide :stepCount="1"></StepGuide>
    </div>

    <!--{{this.preference}}-->

    <div class="layout__padding-clear layout__width-80">
      <div class="text__align-center text__colour-white">
        <div class="layout__padding-clear layout__width-50 layout__padding-40px-0">
          <h2 class="text__colour-teal">Select a Product</h2>
        </div>
      </div>

      <div class="layout__padding-clear layout__width-80 text__align-center">
        <span v-for="(product) in products" :key="product.name">

          <el-button
            v-on:click="selectProduct(product)"
            class="button-dark-teal button__base layout__margin-15"
          >
            <p
              v-show="preference.fCode === product.code.split('A')[0]"
              class="icon-tick text__colour-green text__size-20 layout__position-right"
            ></p>
            <img
              class="layout__width-150px"
              v-bind:src="product.pictureSmall"
            >
            <p class="layout__padding-20px">{{ product.description }}</p>
          </el-button>
        </span>
        <div class="layout__padding-20-0">
          <el-button
            class="layout__position-center button-red layout__width-150px button__base"
            :disabled="(jobItem.printJobSpec.fCode === null) || isLoading"
            v-on:click="next()"
          >
            Confirm
          </el-button>
        </div>
      </div>

      <div class="component__columns-4 text__align-center">
        <p class="black">Your default preference</p>
        <span class="icon-tick text__colour-green text__size-30"></span>
      </div>
    </div>

  </div>

</template>

<script>

import Axios from 'axios';
import Router from '../../../router';
import StepGuide from '@/components/tools/pdfupload/StepGuide.vue';
import { Loading } from 'element-ui';
import { axios } from '@/mixins/Axios.js';
import { dataFormatter } from '@/mixins/DataFormatter.js';
import { backing } from '@/mixins/Backing.js';

export default {
  name: 'products',

  components: {
    StepGuide,
  },

  mixins: [axios, dataFormatter, backing],

  props: {
    searchParams: Object,
    printJob: Object,
  },

  data() {
    return {
      uploadPercentage: '',
      products: [],
      productsHolding: [],
      productSelection: '',
      jobReference: '',
      preference: '',
      preferences: {},
      isLoading: false,
      jobItem: {},
    };
  },

  created() {
    this.jobItem = this.printJob;

    console.log('in the created method');

    let loadingInstance = Loading.service({
      fullscreen: true,
      background: 'white',
    });

    if (window.sessionStorage.getItem('_source') !== 'undefined') {
      if (typeof this.jobItem === 'undefined') {
        this.jobItem = JSON.parse(window.sessionStorage.getItem('_printJob'));
        console.log(this.jobItem);
      }

      this.jobReference = window.sessionStorage.getItem('_propertyName');
    }

    const url = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/Catalogue/FindProductsAsync`;

    const getProducts = {
      'id': 0,
      'fCode': '',
      'stockType': 'string',
      'pageWidth': this.jobItem.printJobSpec.actualPageWidth,
      'pageHeight': this.jobItem.printJobSpec.actualPageHeight,
      'actualPageWidth': 0,
      'actualPageHeight': 0,
      'pageOrientation': 'string',
      'stockWeight': 'string',
      'lamination': 'string',
      'pageCount': this.jobItem.printJobSpec.pageCount,
      'quantity': 0,
    };

    Axios.post(url, getProducts, this.returnHeaderUsingToken())
      .then(response => {
        this.productsHolding = response.data;
        console.log(response);
        if (this.productsHolding.length === 0) {
          console.log('0 matching products');
          this.$nextTick(() => { // Loading should be closed asynchronously
            loadingInstance.close();
          });
          Router.push({
            name: '/instant-print/error',
            params: {
              errorType: 'noproducts',
              printJob: this.jobItem,
            },
          });
        } else if (this.productsHolding.length === 1) {
          console.log('1 matching product');

          const single_product = this.productsHolding[0];

          let url = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/orders/` + this.jobItem.id;

          console.log(url);

          const selectProduct = {
            'printJobSpec': {
              'fCode': single_product.code,
              'name': single_product.name,
              'description': single_product.description,
            },
          };

          Axios.put(url, selectProduct, this.returnHeaderUsingToken())
            .then(response => {
              this.jobItem = response.data;
              this.$nextTick(() => { // Loading should be closed asynchronously
                loadingInstance.close();
              });

              const basketTotals = {
                instantPrint: JSON.parse(window.sessionStorage.getItem('_printJobs'))?.length || 0,
              };

              this.$store.dispatch('incrementPhotofixrTotal', basketTotals);


              console.log('see if single product matches a preference');

              if (JSON.parse(this.returnCookie('_myPreferences'))) {
                const listOfAllPreferences = JSON.parse(this.returnCookie('_myPreferences'));

                for (let indexing = 0; indexing < listOfAllPreferences.length; indexing++) {

                  let a = listOfAllPreferences[indexing];

                  console.log(this.jobItem.printJobSpec.fCode.split('A')[0]);
                  console.log(a.fCode);
                  console.log(this.jobItem.printJobSpec.fCode.split('A')[0] === a.fCode);

                  if (this.jobItem.printJobSpec.fCode.split('A')[0] === a.fCode) {

                    this.preferences = a;

                    console.log('BREAKING OUT OF LOOP - CREATED SINGLE MATCHED PRODUCT');

                    break;

                  } else {
                    this.preferences = {
                      'fCode': '',
                      'finishing': '',
                      'pageCount': 0,
                      'pageHeight': 0,
                      'pageOrientation': '',
                      'pageWidth': 0,
                      'quantity': 0,
                      'stockType': '',
                      'stockWeight': '',
                      'productRef': '',
                    };
                  }
                }

              } else {
                console.log('no preferences that match single product selected');
                this.preferences = {
                  'fCode': '',
                  'finishing': '',
                  'pageCount': 0,
                  'pageHeight': 0,
                  'pageOrientation': '',
                  'pageWidth': 0,
                  'quantity': 0,
                  'stockType': '',
                  'stockWeight': '',
                  'productRef': '',
                };
              }

              window.sessionStorage.setItem('_ipPreference', JSON.stringify(this.preferences));

              Router.push({
                name: '/instant-print/print-selections',
                params: {
                  printJob: this.jobItem,
                  searchParams: this.searchParams,
                  preferences: this.preferences,
                },
              });

              // })
            });
        } else {

          console.log('multiple matching products');

          if (JSON.parse(this.returnCookie('_myPreferences'))) {
            const listOfAllPreferences = JSON.parse(this.returnCookie('_myPreferences'));

            for (let i = 0; i < this.productsHolding.length; i++) {

              let current_matched_product = this.productsHolding[i];

              for (let indexing = 0; indexing < listOfAllPreferences.length; indexing++) {

                let current_preference = listOfAllPreferences[indexing];

                console.log(current_matched_product.code.split('A')[0]);
                console.log(current_preference.fCode);
                console.log(current_preference.fCode === current_matched_product.code.split('A')[0]);

                if (current_preference.fCode === current_matched_product.code.split('A')[0]) {

                  this.preference = current_preference;
                  // this.preferences = a
                  console.log('BREAKING OUT OF LOOP - CREATED MORE THAN ONE MATCHED PRODUCT');
                  break;
                }
              }
              if (this.preference) {
                break;
              }
            }
          }

          if (this.productsHolding.length > 1) {
            console.log('finally moving products after the product length and preferences matched or not matched');
            this.products = this.productsHolding;
          }

          this.$nextTick(() => { // Loading should be closed asynchronously
            loadingInstance.close();
          });
        }
      });
  },

  beforeUpdate() {
    // window.sessionStorage.setItem('_printJob', JSON.stringify(this.jobItem));
    this.handlePrintJobs(this.jobItem);
  },

  methods: {
    next() {
      Router.push({
        name: '/instant-print/print-selections',
        params: {
          printJob: this.jobItem,
          searchParams: this.searchParams,
          preferences: this.preferences,
        },
      });
    },

    selectProduct(product) {
      this.isLoading = true;

      const basketTotals = {
        instantPrint: JSON.parse(window.sessionStorage.getItem('_printJobs'))?.length || 0,
      };

      this.$store.dispatch('incrementPhotofixrTotal', basketTotals);

      console.log(window.sessionStorage.getItem('_token'));

      let selectedProduct = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/orders/` + this.jobItem.id;

      console.log(selectedProduct);

      const selectProduct = {
        'printJobSpec': {
          'fCode': product.code,
          'name': product.name,
          'description': product.description,
        },
      };

      console.log('SELECT PRODUCT');
      console.log(selectProduct);

      Axios.put(selectedProduct, selectProduct, this.returnHeaderUsingToken())
        .then(response => {
          console.log(response);
          this.jobItem = response.data;

          const url = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/orders/` + this.jobItem.id + '?resetJobSpec=true';

          const emptyJobSpec = {
            'printJobSpec': {},
          };

          Axios.put(url, emptyJobSpec, this.returnHeaderUsingToken())
            .then(response => {
              console.log(response);
              this.jobItem = response.data;

              if (this.jobItem.printJobSpec.fCode.split('A')[0] === this.preference.fCode) {
                this.preferences = this.preference;
              } else {
                this.preferences = {
                  'fCode': '',
                  'finishing': '',
                  'pageCount': 0,
                  'pageHeight': 0,
                  'pageOrientation': '',
                  'pageWidth': 0,
                  'quantity': 0,
                  'stockType': '',
                  'stockWeight': '',
                  'productRef': '',
                };
              }

              window.sessionStorage.setItem('_ipPreference', JSON.stringify(this.preferences));

              this.isLoading = false;
            });
        });
    },
  },
};
</script>
